export default {
  signin: {
    title: "Autenticación"
    , tabtitle: "Login"
    , username: { placeholder: "Usuario" }
    , password: { placeholder: "Contraseña" }
    , submit: "Ingresar"
    , forgetpwd: "¿Olvidaste la contraseña?"
  }
  , forgetPwd: {
    title: "Restablecer Contraseña"
    , samePass: "Ambas contraseñas deben coincidir"
    , instructions: "Por favor introduce el usuario"
    , username: { placeholder: "Usuario" }
    , submit: "Enviar"
    , cancel: "Cancelar"
  }
  , expiredPwd: {
    title: "Cambio de Contraseña"
    , tabtitle: "Contraseña Expirada"
    , instructions: "Por favor introduce las nuevas credenciales"
    , samePass: "Ambas contraseñas deben coincidir"
    , password: { placeholder: "Contraseña Actual" }
    , newpassword: { placeholder: "Nueva Contraseña" }
    , confirmpassword: { placeholder: "Confirmar Contraseña" }
    , submit: "Cambiar Contraseña"
  }
  , sessionExpired: {
    title: "Sesión Expirada"
    , titleFirstPart: "Estimado/a"
    , titleSecondPart: ", su sesión ha expirado."
    , instructions: "Aguarde un momento por favor"
  }
  , expiredPwdMessage: {
    titleFirstPart: "Estimado/a"
    , titleSecondPart: ", su contraseña ha vencido y requiere ser modificada."
    , instructions: "Aguarde un momento por favor"
  }
  , forgetPwdMessage: {
    titleFirstPart: "Estimado/a"
    , titleSecondPart: ", se le ha enviado un email con las instrucciones para restablecer su contraseña."
    , instructions: "Aguarde un momento por favor"
  }
  , resetPwd: {
    title: "Restablecer Contraseña"
    , instructions: "Por favor introduce las nuevas credenciales"
    , password: { placeholder: "Nueva Contraseña" }
    , confirmpassword: { placeholder: "Confirmar Contraseña" }
    , submit: "Cambiar Contraseña"
  }
  , auth: {
    SC0011: { text: "Ya existe una sesión abierta con este usuario" }
    , SC0001: { text: "Usuario incorrecto o inexistente" }
    , SC0002: { text: "Contraseña incorrecta" }
    , SC0012: { text: "Contraseña incorrecta" }
    , SC0003: { text: "Usuario bloqueado contacte al Administrador" }
    , SC0009: { text: "Usuario bloqueado contacte al Administrador" }
    , SC0004: { text: "Usuario no asignado a un grupo, contacte al administrador" }
    , SC0013: { text: "Su usuario está bloqueado, consulte al administrador" }
    , SC0005: { text: "Revisar la conexión con el core" }
  }
  , changePassword: {
    DIFF_OLD_PASSWORD: { text: "La contraseña actual es incorrecta" }
    , SAME_NEW_AND_OLD_PASSWORD: { text: "La contraseña no puede ser la misma que la anterior" }
    , SAME_NEW_HIST_PASSWORD: { text: "La contraseña no debe coincidir con las últimas 5 registradas" }
    , INVALID_PASSWORD_RULES_DESC: { text: "La nueva contraseña no cumple con las reglas de seguridad" }
    , INVALID_PASSWORD_MIN_LEN: { text: "La longitud mínima de la contraseña es de 8 caracteres" }
    , INVALID_PASSWORD_ALFANUMERIC: { text: "La contraseña debe contener al menos un número y una letra" }
    , ACCOUNT_LOCKED: { text: "Usuario o cuenta bloqueada" }
    , SAME_NEW_NEW_PASSWORD: { text: "La confirmación de contraseña no coincide" }
    , SC0013: { text: "Su usuario está bloqueado, consulte al administrador" }
  }
  , resetPassword: {
    UNTRUSTED_JWT: { text: "El enlace al que está intentando ingresar ha expirado" }
    , MALFORMED_JWT: { text: "El enlace al que está intentando ingresar ha expirado" }
    , EXPIRED_JWT: { text: "El enlace al que está intentando ingresar ha expirado" }
    , SC0013: { text: "Su usuario está bloqueado, consulte al administrador" }
    , SC0004: { text: "Usuario no asignado a un grupo, contacte al administrador" }
  }
  , expiredPassword: {
    SC0010: { text: "Su contraseña ha vencido y requiere ser modificada." }
    , SC0007: { text: "Su contraseña ha vencido y requiere ser modificada." }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/login/index.js